<template>
  <div class="lee-scroll-select" :style="{color:color}">
    <transition name="slideUp">
      <div class="tandiv" v-if="show">
        <div class="okdiv" @click="chuli"><span>关闭</span></div>
        <template v-if="type==='date'">
          <div class="myk">
            <div class="tit">年</div>
            <ul :style="{transition:isdown?'all .0s':'all .2s ease-in-out',transform:'translateY('+(posy.year+movey.year)+'px)'}">
              <li></li>
              <li></li>
              <li v-for="(item,xh) in year" :key="xh" :class="{cur:item===date.year}">{{item}}</li>
            </ul>
            <div class="cus"></div>
             <div class="zz" @mousedown.prevent="mousedown('year')" @mousemove.prevent="mousemove"
                @mouseup.stop="mouseup" @mouseleave="mouseleave" @touchstart.prevent="touchstart('year')" @touchmove.prevent="touchmove"
                @touchend.stop="touchend"></div>
          </div>
          <div class="myk">
            <div class="tit">月</div>
            <ul :style="{transition:isdown?'all .0s':'all .2s ease-in-out',transform:'translateY('+(posy.month+movey.month)+'px)'}">
              <li></li>
              <li></li>
              <li v-for="(item,xh) in 12" :key="xh" :class="{cur:item===date.month}">{{item>=10?item:'0'+item}}</li>
            </ul>
            <div class="cus"></div>
             <div class="zz" @mousedown.prevent="mousedown('month')" @mousemove.prevent="mousemove"
                @mouseup.stop="mouseup" @mouseleave="mouseleave" @touchstart.prevent="touchstart('month')" @touchmove.prevent="touchmove"
                @touchend.stop="touchend"></div>
          </div>
          <div class="myk">
            <div class="tit">日</div>
            <ul :style="{transition:isdown?'all .0s':'all .2s ease-in-out',transform:'translateY('+(posy.day+movey.day)+'px)'}">
              <li></li>
              <li></li>
              <li v-for="(item,xh) in 31" :key="xh" :class="{cur:item===date.day}">{{item>=10?item:'0'+item}}</li>
            </ul>
            <div class="cus"></div>
             <div class="zz" @mousedown.prevent="mousedown('day')" @mousemove.prevent="mousemove"
                @mouseup.stop="mouseup" @mouseleave="mouseleave" @touchstart.prevent="touchstart('day')" @touchmove.prevent="touchmove"
                @touchend.stop="touchend"></div>
          </div>
        </template>
        <template v-if="type==='time'">
          <div class="myk">
            <div class="tit">时</div>
            <ul :style="{transition:isdown?'all .0s':'all .2s ease-in-out',transform:'translateY('+(posy.hour+movey.hour)+'px)'}">
              <li></li>
              <li></li>
              <li v-for="(item,xh) in 24" :key="xh" :class="{cur:item===date.hour}">
                {{item>=10?item!=24?item:'00':'0'+item}}
              </li>
            </ul>
            <div class="cus"></div>
             <div class="zz" @mousedown.prevent="mousedown('hour')" @mousemove.prevent="mousemove"
                @mouseup.stop="mouseup" @mouseleave="mouseleave" @touchstart.prevent="touchstart('hour')" @touchmove.prevent="touchmove"
                @touchend.stop="touchend"></div>
          </div>
          <div class="myk">
            <div class="tit">分</div>
            <ul :style="{transition:isdown?'all .0s':'all .2s ease-in-out',transform:'translateY('+(posy.min+movey.min)+'px)'}">
              <li></li>
              <li></li>
              <li v-for="(item,xh) in 60" :key="xh" :class="{cur:item===date.min}">
                {{item>=10?item!=60?item:'00':'0'+item}}
              </li>
            </ul>
            <div class="cus"></div>
             <div class="zz" @mousedown.prevent="mousedown('min')" @mousemove.prevent="mousemove"
                @mouseup.stop="mouseup" @mouseleave="mouseleave" @touchstart.prevent="touchstart('min')" @touchmove.prevent="touchmove"
                @touchend.stop="touchend"
                ></div>
          </div>
          <div class="myk">
            <div class="tit">秒</div>
            <ul :style="{transition:isdown?'all .0s':'all .2s ease-in-out',transform:'translateY('+(posy.sec+movey.sec)+'px)'}">
              <li></li>
              <li></li>
              <li v-for="(item,xh) in 60" :key="xh" :class="{cur:item===date.sec}">
                {{item>=10?item!=60?item:'00':'0'+item}}
              </li>
            </ul>
            <div class="cus"></div>
             <div class="zz" @mousedown.prevent="mousedown('sec')" @mousemove.prevent="mousemove"
                @mouseup.stop="mouseup" @mouseleave="mouseleave" @touchstart.prevent="touchstart('sec')" @touchmove.prevent="touchmove"
                @touchend.stop="touchend"
                ></div>
          </div>
        </template>
      </div>
    </transition>
    <transition name="fade">
      <div class="mark" @click="chuli" v-if="show"></div>
    </transition>
  </div>
</template>
<script>
export default {
    name: 'LeeScrollSelect',
    inheritAttrs: false,
    data() {
        return {
            show: false,
            date: {
                year: '',
                month: '',
                day: '',
                hour: '',
                min: '',
                sec: ''
            },
            posy: {
                year: 0,
                month: 0,
                day: 0,
                hour: '',
                min: '',
                sec: ''
            },
            movey: {
                year: 0,
                month: 0,
                day: 0,
                hour: '',
                min: '',
                sec: ''
            },
            oldy: 0,
            isdown: false,
            which: '',
            maxy: 0,
            perh: 35
        }
    },
    mounted() {

    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'date' //默认default
        },
        color: {
            type: String,
            default: '#46bd87' //默认default
        }
    },
    methods: {
        chuli() {
            let senddata = {}
            if (this.type === 'date') {
                senddata = {
                    year: this.date.year,
                    month: this.date.month,
                    day: this.date.day,
                }
            }else if (this.type === 'time') {
                senddata = {
                    hour: this.date.hour,
                    min: this.date.min,
                    sec: this.date.sec,
                }
            }
            this.$emit('change', senddata)
            this.$emit('input', false)
        },
        mousedown(which) {
            this.oldy = event.pageY
            this.isdown = true
            this.which = which
        },
        mousemove() {
            if (this.isdown) {
                this.movey[this.which] = event.pageY - this.oldy
                if(this.posy[this.which]>=0){
                    this.movey[this.which] = (event.pageY - this.oldy)*(1/3)
                }
                if(this.posy[this.which]<= this.maxy){
                    this.movey[this.which] = (event.pageY - this.oldy)*(1/3)
                }
            }
        },
        mouseup() {
            let year = new Date().getFullYear()
            this.isdown = false
            this.movey[this.which] = 0
            this.posy[this.which] += event.pageY - this.oldy
            //临界判断
            if (this.posy[this.which] > 0) {
                this.posy[this.which] = 0
            }
            if (this.posy[this.which] <= this.maxy) {
                this.posy[this.which] = this.maxy
            }
            //转化
            let xh = Math.ceil(Math.abs(this.posy[this.which]) / this.perh)
            this.$set(this.posy, this.which, -xh * this.perh)
            if (this.which === 'year') {
                this.$set(this.date, this.which, year - xh)
            } else {
                this.$set(this.date, this.which, xh + 1)
            }
        },
        mouseleave(){
            let year = new Date().getFullYear()
            this.isdown = false
            this.posy[this.which] += this.movey[this.which]//把mousemove的值传给他
            this.movey[this.which] = 0//movey 重置为0
            //临界判断
            if (this.posy[this.which] > 0) {
                this.posy[this.which] = 0
            }
            if (this.posy[this.which] <= this.maxy) {
                this.posy[this.which] = this.maxy
            }
            //转化
            let xh = Math.ceil(Math.abs(this.posy[this.which]) / this.perh)
            this.$set(this.posy, this.which, -xh * this.perh)
            if (this.which === 'year') {
                this.$set(this.date, this.which, year - xh)
            } else {
                this.$set(this.date, this.which, xh + 1)
            }
        },
        touchstart(which) {
            this.oldy = event.targetTouches[0].pageY
            this.isdown = true
            this.which = which
        },
        touchmove() {
            if (this.isdown) {
                this.movey[this.which] = event.targetTouches[0].pageY - this.oldy
                 if(this.posy[this.which]>=0){
                    this.movey[this.which] = (event.targetTouches[0].pageY - this.oldy)*(1/3)
                }
                if(this.posy[this.which]<= this.maxy){
                    this.movey[this.which] = (event.targetTouches[0].pageY - this.oldy)*(1/3)
                }
            }
        },
        touchend() {
            let year = new Date().getFullYear()
            this.isdown = false
            this.movey[this.which] = 0
            this.posy[this.which] += event.changedTouches[0].pageY - this.oldy
            //临界判断
            if (this.posy[this.which] > 0) {
                this.posy[this.which] = 0
            }
            if (this.posy[this.which] <= this.maxy) {
                this.posy[this.which] = this.maxy
            }
            //转化
            let xh = Math.ceil(Math.abs(this.posy[this.which]) / this.perh)
            this.$set(this.posy, this.which, -xh * this.perh)
            if (this.which === 'year') {
                this.$set(this.date, this.which, year - xh)
            } else {
                this.$set(this.date, this.which, xh + 1)
            }
        }
    },
    watch: {
        which: {
            immediate: true,
            handler(value) {
                if (value === 'year') {
                    this.maxy = -79 * 35
                } else if (value === 'month') {
                    this.maxy = -11 * 35
                } else if (value === 'day') {
                    this.maxy = -30 * 35
                } else if (value === 'hour') {
                    this.maxy = -23 * 35
                } else if (value === 'min') {
                    this.maxy = -59 * 35
                } else if (value === 'sec') {
                    this.maxy = -59 * 35
                }

            }
        },
        value: {
            immediate: true,
            handler(value) {
                this.show = value
            }
        },
        show: {
            immediate: true,
            handler(value) {
                if (value) {
                    let now = new Date()
                    let year = now.getFullYear()
                    let month = now.getMonth() + 1
                    let day = now.getDate()
                    let hour = now.getHours()
                    let min = now.getMinutes()
                    let sec = now.getSeconds()
                    this.$set(this.date, 'year', year)
                    this.$set(this.date, 'month', month)
                    this.$set(this.date, 'day', day)
                    this.$set(this.date, 'hour', hour)
                    this.$set(this.date, 'min', min)
                    this.$set(this.date, 'sec', sec)
                    this.$set(this.posy, 'year', 0)
                    this.$set(this.posy, 'month', -(month - 1) * this.perh)
                    this.$set(this.posy, 'day', -(day - 1) * this.perh)
                    this.$set(this.posy, 'hour', -(hour - 1) * this.perh)
                    this.$set(this.posy, 'min', -(min - 1) * this.perh)
                    this.$set(this.posy, 'sec', -(sec - 1) * this.perh)

                } else {
                    //document.body.style.cssText = ""
                }
            }
        }
    },
    computed: {
        year: function () {
            let years = []
            let date = new Date().getFullYear()
            for (let i = 0; i < 80; i++) {
                years.push(date)
                date -= 1;
            }
            return years
        }
    }
};
</script>
<style scoped>
ul{
  padding: 0;}

.tandiv {
  position: fixed;
  width: 100%;
  height: auto;
  bottom: 0;
  left: 0;
  z-index: 66;
  background: #fff;
  display: flex;
}
.tandiv .zz{
  height: calc(100% - 35px);
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  background: -webkit-linear-gradient(rgba(255,255,255,1) 5%,rgba(255,255,255,0) , rgba(255,255,255,1) 95%);
  z-index: 44;
}

.tandiv .myk {
  width: 33.33%;
  overflow: hidden;
  height: 210px;
  position: relative;
}

.tandiv .myk .tit {
  height: 35px;
  color: currentColor;
  text-align: center;
  line-height: 35px;
  background: #eee;
  position: relative;
  z-index: 44;
}

.tandiv .myk ul {
  position: relative;
  z-index: 33;
}


.tandiv li {
  line-height: 35px;
  height: 35px;
  display: block;
  text-align: center;
  color: #333;
  scroll-snap-align: start;
}

.tandiv li.cur {
  color: currentColor;
  font-weight: bold;
}

.tandiv .cus {
  top: 105px;
  height: 35px;
  position: absolute;
  left: 0px;
  border-top: solid 1px #ddd;
  border-bottom: solid 1px #ddd;
  width: 100%;
  background: none;
}


.mark {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, .8);
  z-index: 36;
}

.okdiv {
  width: 15%;
  height: 25px;
  position: absolute;
  right: 0;
  top: -25px;
  line-height: 25px;
  text-align: center;
  background: currentColor;
  font-size: 12px;
  cursor: pointer;
}
.okdiv span{
  color: #fff;}

/*遮罩動畫*/

.fade-enter-active,
.fade-leave-active {
  transition: all .3s;
  visibility: visible;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  visibility: hidden;
}


/*支付選擇動畫*/

.slideUp-enter-active,
.slideUp-leave-active {
  transition: transform .3s;
  transform: translate3d(0, 0, 0);
}

.slideUp-enter,
.slideUp-leave-to {
  transform: translate3d(0, 120%, 0);
}
</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeScrollSelect.vue